import { SlidersHorizontal, XCircleIcon } from "lucide-react";

export const FilterButton = ({ label = "Filter", filterCount, onClick, onClear }) => {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 px-4 py-2 bg-transparent border border-[#5A4479] rounded-full text-[#CCCCCC] hover:bg-[#2A2A2A] transition-colors duration-200 relative"
    >
      <SlidersHorizontal className="w-4 h-4" />
      <span>{label}</span>

      {filterCount > 0 && (
        <>
          <span className="ml-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs absolute -right-2 -top-1">
            {filterCount}
          </span>
          {onClear && (
            <XCircleIcon
              className="w-5 h-5 text-white hover:text-white"
              onClick={(e) => {
                e.stopPropagation();
                onClear();
              }}
            />
          )}
        </>
      )}
    </button>
  );
};